import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export const Footer = () => {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-[#1B2A4A] text-white/60 py-12 px-4 text-center text-sm border-t border-white/10" data-id="element-56">
      <div className="max-w-6xl mx-auto flex flex-col items-center space-y-6" data-id="element-57">
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-6 text-white/80" data-id="element-58">
          <button onClick={() => setOpenModal('privacy')} className="hover:text-[#2ABFBF] transition-colors underline decoration-transparent hover:decoration-[#2ABFBF] underline-offset-4" data-id="element-59">
            Política de Privacidad
          </button>
          <button onClick={() => setOpenModal('terms')} className="hover:text-[#2ABFBF] transition-colors underline decoration-transparent hover:decoration-[#2ABFBF] underline-offset-4" data-id="element-60">
            Términos y Condiciones
          </button>
        </div>

        {/* Copyright & Disclaimer */}
        <div className="space-y-2 max-w-2xl mx-auto" data-id="element-61">
          <p data-id="element-62">
            © {new Date().getFullYear()} La Ruta Clara. Todos los derechos
            reservados.
          </p>
          <p className="opacity-70 text-xs leading-relaxed" data-id="element-63">
            Este producto es una guía educativa y no sustituye el consejo médico
            profesional. Si tienes preocupaciones sobre el desarrollo de tu
            hijo, consulta siempre a tu pediatra.
          </p>
        </div>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-64">
        <div className="space-y-4" data-id="element-65">
          <p data-id="element-66">
            <strong data-id="element-67">
              Última actualización: {new Date().toLocaleDateString()}
            </strong>
          </p>
          <p data-id="element-68">
            En La Ruta Clara, respetamos su privacidad y estamos comprometidos a
            protegerla mediante el cumplimiento de esta política.
          </p>
          <h4 data-id="element-69">1. Información que recopilamos</h4>
          <p data-id="element-70">
            Podemos recopilar información personal que usted nos proporciona
            voluntariamente al realizar una compra, suscribirse a nuestro
            boletín o contactarnos. Esto puede incluir su nombre, dirección de
            correo electrónico y detalles de pago.
          </p>
          <h4 data-id="element-71">2. Uso de su información</h4>
          <p data-id="element-72">
            Utilizamos su información para procesar sus pedidos, entregarle los
            productos digitales, enviarle actualizaciones importantes y mejorar
            nuestros servicios. No vendemos su información personal a terceros.
          </p>
          <h4 data-id="element-73">3. Seguridad de los datos</h4>
          <p data-id="element-74">
            Implementamos medidas de seguridad diseñadas para proteger su
            información personal contra pérdidas accidentales y acceso no
            autorizado.
          </p>
          <h4 data-id="element-75">4. Cookies</h4>
          <p data-id="element-76">
            Nuestro sitio web puede utilizar cookies para mejorar su experiencia
            de navegación. Usted puede configurar su navegador para rechazar
            todas o algunas cookies.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-77">
        <div className="space-y-4" data-id="element-78">
          <p data-id="element-79">
            <strong data-id="element-80">
              Última actualización: {new Date().toLocaleDateString()}
            </strong>
          </p>
          <p data-id="element-81">
            Por favor, lea estos términos y condiciones cuidadosamente antes de
            utilizar nuestro sitio web o comprar nuestros productos.
          </p>
          <h4 data-id="element-82">1. Propiedad Intelectual</h4>
          <p data-id="element-83">
            Todo el contenido incluido en "La Ruta Clara" (textos, gráficos,
            logotipos, imágenes y software) es propiedad de La Ruta Clara y está
            protegido por leyes de derechos de autor. La compra le otorga una
            licencia personal y no transferible para uso privado. No está
            permitida la redistribución o reventa.
          </p>
          <h4 data-id="element-84">2. Descargo de Responsabilidad Médica</h4>
          <p data-id="element-85">
            "La Ruta Clara" es un recurso educativo e informativo. No constituye
            consejo médico, diagnóstico ni tratamiento. El uso de la información
            proporcionada es bajo su propio riesgo. Siempre busque el consejo de
            su médico o proveedor de salud calificado.
          </p>
          <h4 data-id="element-86">3. Política de Reembolso</h4>
          <p data-id="element-87">
            Debido a la naturaleza digital de nuestros productos, ofrecemos una
            garantía de satisfacción limitada. Si tiene problemas con su
            descarga o el contenido, contáctenos para resolverlo.
          </p>
          <h4 data-id="element-88">4. Modificaciones</h4>
          <p data-id="element-89">
            Nos reservamos el derecho de revisar y actualizar estos términos en
            cualquier momento. Todos los cambios entran en vigor inmediatamente
            después de su publicación.
          </p>
        </div>
      </Modal>
    </footer>;
};